// extracted by mini-css-extract-plugin
module.exports = {"fileStagingArea":"widget-space--fileStagingArea--3Fudn","files":"widget-space--files--2Vjst","chipContainer":"widget-space--chipContainer--i2E6U"};